import { useSelector } from 'react-redux';
import './App.css';
import WhatsApp from'./assets/WhatsApp.svg';
import MainRoute from './MainRoute';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

function App() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const phoneNumber = "+99676688"; // Replace with the actual phone number
  const message = "Hello, I need help!"; // Default message

  const openWhatsApp = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };
  document
    .querySelector("html")
    .setAttribute("dir", currentLocal.language === "English" ? "ltr" : "rtl");

  return (
<div className={ currentLocal.language ==="English" ?'App':"ar_app"}>
<MainRoute/>
            <ToastContainer />

      <button
        onClick={openWhatsApp}
        style={{
          position: "fixed",
          bottom: "20px",
right: currentLocal.language === "English" ? "20px" : undefined,
left: currentLocal.language === "English" ? undefined : "20px",

          backgroundColor: "#25D366",
          color: "white",
          border: "none",
          padding: "10px 12px",
          borderRadius: "50%",
          fontSize: "18px",
          cursor: "pointer",
          boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",
          zIndex:10000000000
        }}
      >
        <img src={WhatsApp} alt='WhatsApp'
          style={{
            width: "25px"
          }}
        />
      </button>
</div>

  );
}

export default App;
